import React from "react";
import { Link, useLocation } from "react-router-dom";

const EcoBookNav: React.FC = () => {
  const headers: {
    name: string;
    href: string;
  }[] = [
    { name: "Home", href: "/ecobook" },
    // { name: "Market Place", href: "/marketplace" },
    { name: "Community", href: "/ecobook/my-communities" },
  ];

  const { pathname } = useLocation();

  return (
    <div className="w-full  relative">
      <ul className="lg:bg-white bg-[#2157590F] rounded-lg lg:rounded w-full shadow-sm flex h-10 text-center items-center">
        {headers.map((header) => (
          <li
            className={`ecoHeader ${
              pathname === header.href ? "activeLink" : 'ecoHeader'
            }`}
            key={header.name}
          >
            <Link to={header.href}>{header.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EcoBookNav;
